import React from "react";

const RnDSection: React.FC = () => {
  return (
    <section className="relative min-h-screen w-full overflow-hidden">
      {/* ================= Background Image ================= */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/rndsection.avif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* ================= Soft Global Overlay ================= */}
      <div className="absolute inset-0 bg-black/30" />

      {/* ================= Directional Gradients (Hero-style) ================= */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/25 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

      {/* ================= Content ================= */}
      <div className="relative z-10 mt-44 flex min-h-[calc(100vh-180px)]">
        <div className="w-full px-6 md:px-20 max-w-7xl">

          {/* ===== Headline ===== */}
          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-thin text-white mb-6 leading-tight"
            style={{
              textShadow:
                "0 4px 12px rgba(0,0,0,0.85), 0 0 40px rgba(0,0,0,0.6)",
            }}
          >
            Research and
            <br />
            <span className="text-white">
              Development
            </span>
          </h1>

          {/* ===== Description ===== */}
          <p
            className="text-xl md:text-2xl lg:text-2xl text-white/95 mb-12 max-w-3xl leading-relaxed font-light tracking-wide"
            style={{
              textShadow: "0 3px 10px rgba(0,0,0,0.9)",
            }}
          >
            Pioneering innovations to drive the future of portable
            energy solutions.
          </p>
        </div>
      </div>
    </section>
  );
};

export default RnDSection;
